document.addEventListener('DOMContentLoaded', function () {
    // ═══════════════════════════════════════════════════════════
    // ⚙️ CONFIGURACIÓN POR DEFECTO
    // ═══════════════════════════════════════════════════════════
    const defaultSettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        navigation: { nextEl: '.swiper-next', prevEl: '.swiper-prev' },
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: { el: '.swiper-pagination', clickable: true }
    };

    // ═══════════════════════════════════════════════════════════
    // 🔄 INICIALIZAR SWIPER
    // ═══════════════════════════════════════════════════════════
    const initializeSwiper = function (element, index) {
        const swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultSettings;
        element.setAttribute('data-swiper-' + index, '');
        const swiperInstance = new Swiper('[data-swiper-' + index + ']', swiperConfig);
        element.swiper = swiperInstance;
        return swiperInstance;
    };

    // ═══════════════════════════════════════════════════════════
    // 🔢 CUSTOM COUNT
    // ═══════════════════════════════════════════════════════════
    const CustomCount = function (swiper) {
        if (swiper.passedParams && swiper.passedParams.customcount) {
            const countContainers = document.querySelectorAll(swiper.passedParams.customcount);
            const updateCount = function () {
                countContainers.forEach(function (container) {
                    container.innerHTML = '0' + (swiper.realIndex + 1);
                });
            };
            updateCount();
            swiper.on('slideChange', updateCount);
        }
    };

    // ═══════════════════════════════════════════════════════════
    // 🎮 CUSTOM CONTROLS
    // ═══════════════════════════════════════════════════════════
    const CustomControls = function (swiper, allSwipers) {
        const getTargetSwipers = function (customControl, allSwipers) {
            if (!customControl) return [];
            const targetIds = customControl.split('#').filter(function (id) { return id.trim() !== ''; });
            return allSwipers.filter(function (s) { return targetIds.indexOf(s.el.id) !== -1; });
        };

        const updateSwiperControls = function (swiper, targetSwipers) {
            if (targetSwipers.length > 0) {
                swiper.controller.control = targetSwipers.filter(function (v, i, a) { return a.indexOf(v) === i; });
            }
        };

        const customControl = swiper.passedParams && swiper.passedParams.customcontrol;
        const targetSwipers = getTargetSwipers(customControl, allSwipers);
        updateSwiperControls(swiper, targetSwipers);

        targetSwipers.forEach(function (targetSwiper) {
            const targetCustomControl = targetSwiper.passedParams && targetSwiper.passedParams.customcontrol;
            if (targetCustomControl) {
                const secondaryTargetSwipers = getTargetSwipers(targetCustomControl, allSwipers);
                const combinedSwipers = [swiper].concat(secondaryTargetSwipers).concat(targetSwiper.controller.control || []);
                updateSwiperControls(targetSwiper, combinedSwipers.filter(function (v, i, a) { return a.indexOf(v) === i; }));
            }
        });
    };

    // ═══════════════════════════════════════════════════════════
    // 📊 CUSTOM CONTROLS COLUMNS
    // ═══════════════════════════════════════════════════════════
    const CustomControlsColumns = function (allSwipers) {
        allSwipers.forEach(function (swiper) {
            const customControl = swiper.passedParams && swiper.passedParams.customcontrolcolumns;
            if (customControl && !swiper._customControlColumnsInitialized) {
                swiper._customControlColumnsInitialized = true;
                const mainSwiper = swiper;

                const targetSwiperElements = document.querySelectorAll(customControl);
                if (targetSwiperElements.length === 0) {
                    console.warn('No elements found for selector: ' + customControl);
                    return;
                }

                const targetSwipers = Array.from(targetSwiperElements)
                    .map(function (el) { return allSwipers.find(function (s) { return s.el === el; }); })
                    .filter(Boolean);

                if (targetSwipers.length === 0) {
                    console.warn('No Swiper instances found for selector: ' + customControl);
                    return;
                }

                mainSwiper.on('slideChange', function () {
                    const activeIndex = mainSwiper.realIndex;
                    targetSwipers.forEach(function (targetSwiper) {
                        if (targetSwiper.activeIndex !== activeIndex) {
                            targetSwiper.slideTo(activeIndex);
                        }
                    });
                });
            }
        });
    };

    // ═══════════════════════════════════════════════════════════
    // 🎯 DATA-SWIPER-GOTO (CORREGIDO & COMPATIBLE)
    // ═══════════════════════════════════════════════════════════
    const attachGotoEvent = function (item, slider, targetIndex) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const swiper = slider.swiper;
            if (!swiper) return;

            if (swiper.params && swiper.params.loop) {
                if (typeof swiper.slideToLoop === 'function') {
                    swiper.slideToLoop(targetIndex);
                } else {
                    swiper.slideTo(targetIndex);
                }
            } else {
                swiper.slideTo(targetIndex);
            }

            const targetSelector = item.dataset.swipertarget;
            let tabsToReset;

            if (targetSelector) {
                tabsToReset = document.querySelectorAll('[data-swiper-goto][data-swipertarget="' + targetSelector + '"]');
            } else {
                const container = item.closest('.tabs-amenities__tabs') || item.closest('.swiper-slider') || document.body;
                tabsToReset = container.querySelectorAll('[data-swiper-goto]');
            }

            tabsToReset.forEach(function (tab) {
                tab.classList.remove('active');
            });

            item.classList.add('active');
        });
    };

    const initSwiperGoto = function () {
        const gotoElements = document.querySelectorAll('[data-swiper-goto]');
        gotoElements.forEach(function (item) {
            if (item._swiperGotoInitialized) return;
            item._swiperGotoInitialized = true;

            const targetIndex = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto, 10) : 0;
            const sliderSelector = item.dataset.swipertarget;
            let slider = sliderSelector ? document.querySelector(sliderSelector) : item.closest('.swiper-slider');

            if (!slider || !slider.swiper) {
                const retry = function (attempts) {
                    if (attempts >= 5) return;
                    slider = sliderSelector ? document.querySelector(sliderSelector) : item.closest('.swiper-slider');
                    if (slider && slider.swiper) {
                        attachGotoEvent(item, slider, targetIndex);
                    } else {
                        setTimeout(function () { retry(attempts + 1); }, 100);
                    }
                };
                retry(0);
                return;
            }

            attachGotoEvent(item, slider, targetIndex);
        });
    };

    // ═══════════════════════════════════════════════════════════
    // 🚀 INICIALIZACIÓN PRINCIPAL
    // ═══════════════════════════════════════════════════════════
    const allSwipers = [];

    document.querySelectorAll('.swiper-slider').forEach(function (element, index) {
        const swiper = initializeSwiper(element, index);
        allSwipers.push(swiper);

        CustomCount(swiper);

        if (swiper.params && swiper.params.autoplay) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    // if (entry.isIntersecting) {
                    //     swiper.autoplay.start();
                    // } else {
                    //     swiper.autoplay.stop();
                    // }
                });
            }, { threshold: 0.5 });
            observer.observe(element);
        }
    });

    allSwipers.forEach(function (swiper) {
        CustomControls(swiper, allSwipers);
    });

    CustomControlsColumns(allSwipers);
    initSwiperGoto();

    // ═══════════════════════════════════════════════════════════
    // 📑 TABS AMENITIES: VERTICAL (DESKTOP) & ACCORDION (MOBILE)
    // ═══════════════════════════════════════════════════════════
    const parseGroups = function (slide) {
        if (slide._parsedGroups) return slide._parsedGroups;

        // Guardamos el HTML original antes de cualquier modificación
        if (!slide._originalHTML) {
            slide._originalHTML = slide.innerHTML;
        }

        const groups = [];
        let current = null;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = slide._originalHTML;

        Array.from(tempDiv.childNodes).forEach(function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'H2') {
                if (current) groups.push(current);
                current = { title: node.innerHTML, content: '' };
            } else if (current) {
                current.content += node.outerHTML;
            }
        });
        if (current) groups.push(current);
        
        slide._parsedGroups = groups;
        return groups;
    };

    const buildVerticalLayout = function (slide, groups) {
        slide.classList.add('is-vertical-tabs');
        slide.classList.remove('is-accordion');

        const wrapper = document.createElement('div');
        wrapper.className = 'tabs-amenities__vertical';
        const nav = document.createElement('ul');
        nav.className = 'tabs-amenities__vertical-nav';
        const contentArea = document.createElement('div');
        contentArea.className = 'tabs-amenities__vertical-content';

        groups.forEach(function (group, index) {
            const navItem = document.createElement('li');
            navItem.className = 'tabs-amenities__vertical-nav-item';
            const navLink = document.createElement('a');
            navLink.href = '#';
            navLink.className = 'tabs-amenities__vertical-link' + (index === 0 ? ' active' : '');
            navLink.innerHTML = group.title;
            navItem.appendChild(navLink);
            nav.appendChild(navItem);

            const panel = document.createElement('div');
            panel.className = 'tabs-amenities__vertical-panel' + (index === 0 ? ' active' : '');
            panel.innerHTML = group.content;
            contentArea.appendChild(panel);

            navLink.addEventListener('click', function (e) {
                e.preventDefault();
                nav.querySelectorAll('.tabs-amenities__vertical-link').forEach(function (l) { l.classList.remove('active'); });
                contentArea.querySelectorAll('.tabs-amenities__vertical-panel').forEach(function (p) { p.classList.remove('active'); });
                navLink.classList.add('active');
                panel.classList.add('active');
            });
        });

        wrapper.appendChild(nav);
        wrapper.appendChild(contentArea);
        slide.innerHTML = '';
        slide.appendChild(wrapper);
    };

    const buildAccordionLayout = function (slide, groups) {
        slide.classList.add('is-accordion');
        slide.classList.remove('is-vertical-tabs');

        const wrapper = document.createElement('div');
        wrapper.className = 'tabs-amenities__accordion';

        groups.forEach(function (group, index) {
            const item = document.createElement('div');
            item.className = 'tabs-amenities__accordion-item';

            const header = document.createElement('div');
            header.className = 'tabs-amenities__accordion-header' + (index === 0 ? ' active' : '');
            header.innerHTML = group.title;
            header.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

            const panel = document.createElement('div');
            panel.className = 'tabs-amenities__accordion-panel' + (index === 0 ? ' active' : '');
            panel.innerHTML = group.content;

            header.addEventListener('click', function (e) {
                e.preventDefault();
                const isActive = header.classList.contains('active');
                
                wrapper.querySelectorAll('.tabs-amenities__accordion-header').forEach(function (h) {
                    h.classList.remove('active');
                    h.setAttribute('aria-expanded', 'false');
                });
                wrapper.querySelectorAll('.tabs-amenities__accordion-panel').forEach(function (p) {
                    p.classList.remove('active');
                    p.style.maxHeight = '0px';
                });

                if (!isActive) {
                    header.classList.add('active');
                    header.setAttribute('aria-expanded', 'true');
                    panel.classList.add('active');
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });

            item.appendChild(header);
            item.appendChild(panel);
            wrapper.appendChild(item);
        });

        slide.innerHTML = '';
        slide.appendChild(wrapper);

        const activePanel = wrapper.querySelector('.tabs-amenities__accordion-panel.active');
        if (activePanel) {
            activePanel.style.maxHeight = activePanel.scrollHeight + 'px';
        }
    };

    const initTabsAmenitiesLayout = function () {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        
        document.querySelectorAll('.tabs-amenities__content--vertical .tabs-amenities__item').forEach(function (slide) {
            const groups = parseGroups(slide);
            if (groups.length === 0) return;

            if (!isDesktop) {
                if (!slide.classList.contains('is-accordion')) {
                    buildAccordionLayout(slide, groups);
                }
            } else {
                if (!slide.classList.contains('is-vertical-tabs')) {
                    buildVerticalLayout(slide, groups);
                }
            }
        });
    };

    initTabsAmenitiesLayout();

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            initTabsAmenitiesLayout();
        }, 250);
    });
});